/* One page's cart writes share a queue; Shopify remains the cross-tab authority. */
(function () {
  'use strict';
  if (window.ApellaCartMutations) return;
  let tail = Promise.resolve();
  let version = 0;
  let pending = 0;

  function enqueue(work, source) {
    pending += 1;
    const run = tail.then(work);
    const settled = run.finally(function () {
      version += 1;
      pending -= 1;
      if (typeof document.dispatchEvent === 'function' && typeof CustomEvent === 'function') {
        document.dispatchEvent(new CustomEvent('apella:cart-mutation', { detail: { source: source || 'cart', revision: version } }));
      }
    });
    tail = settled.catch(function () {});
    return settled;
  }

  async function whenIdle() {
    let observed;
    do { observed = tail; await observed; } while (observed !== tail);
  }

  function identity(line) {
    const entries = Object.entries(line.properties || {}).sort(function (a, b) { return a[0].localeCompare(b[0]); });
    return JSON.stringify({
      variantId: String(line.variant_id || line.id || ''),
      properties: entries,
      sellingPlanId: String(line.selling_plan_allocation?.selling_plan?.id || line.selling_plan || ''),
      parent: line.parent_relationship || line.parent_id || null,
    });
  }

  async function resolveLine(key, lineIdentity) {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Your cart could not be checked. Please try again.');
    const cart = await response.json();
    const keyed = cart.items.filter(function (line) { return line.key === key; });
    if (keyed.length === 1) return keyed[0];
    const matches = lineIdentity ? cart.items.filter(function (line) { return identity(line) === lineIdentity; }) : [];
    if (matches.length !== 1) throw new Error('Your cart changed. Please refresh it before updating this item.');
    return matches[0];
  }

  async function paidUpdates(updates) {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Your cart could not be checked. Please try again.');
    const cart = await response.json();
    const result = {};
    for (const [variantId, quantity] of Object.entries(updates)) {
      const all = cart.items.filter(function (line) { return String(line.variant_id || line.id) === String(variantId); });
      const managed = all.filter(function (line) { return line.properties?._apella_shagun === 'shagun-native-v1'; });
      if (!managed.length) { result[variantId] = quantity; continue; }
      const paid = all.filter(function (line) { return line.properties?._apella_shagun !== 'shagun-native-v1'; });
      if (paid.length !== 1) throw new Error('Please update this envelope in your cart to keep your complimentary gift separate.');
      result[paid[0].key] = quantity;
    }
    return result;
  }

  window.ApellaCartMutations = { enqueue, whenIdle, revision: function () { return version; }, pending: function () { return pending; }, identity, resolveLine, paidUpdates };
})();
